/* Weekly deals countdown (H-08): counts down to Sunday 23:59:59 Vilnius time, then starts the next week by itself.
   Vilnius wall-clock time is used whatever the visitor's own time zone. */
(() => {
  const TIME_ZONE = 'Europe/Vilnius';
  const DAY = 86400;
  const WEEKDAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: TIME_ZONE, weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });

  // Seconds left until the end of this week's Sunday in Vilnius.
  const secondsLeft = (date) => {
    const parts = Object.fromEntries(formatter.formatToParts(date).map((part) => [part.type, part.value]));
    const elapsedToday = Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second);
    const daysAfterToday = (7 - WEEKDAYS[parts.weekday]) % 7;
    return daysAfterToday * DAY + (DAY - elapsedToday);
  };

  const split = (seconds) => ({
    days: Math.floor(seconds / DAY),
    hours: Math.floor((seconds % DAY) / 3600),
    minutes: Math.floor((seconds % 3600) / 60),
    seconds: seconds % 60
  });

  const pad = (value) => String(value).padStart(2, '0');

  const render = (timer) => {
    const left = split(secondsLeft(new Date()));
    timer.querySelector('[data-countdown-days]').textContent = pad(left.days);
    timer.querySelector('[data-countdown-hours]').textContent = pad(left.hours);
    timer.querySelector('[data-countdown-minutes]').textContent = pad(left.minutes);
    const secondsEl = timer.querySelector('[data-countdown-seconds]');
    if (secondsEl) secondsEl.textContent = pad(left.seconds);
    timer.setAttribute('aria-label', timer.dataset.labelTemplate
      .replace('[days]', left.days).replace('[hours]', left.hours).replace('[minutes]', left.minutes));
  };

  const start = () => {
    const timers = document.querySelectorAll('[data-weekly-countdown]');
    timers.forEach((timer) => { render(timer); timer.hidden = false; });
    if (timers.length) setInterval(() => timers.forEach(render), 1000);
  };

  window.RosviaWeeklyCountdown = { secondsLeft, split };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
